import { useMutation } from "@apollo/client";
import { EXPORT_PAYMENT_CREATE } from "components/gql/gql_queries_export";
import { logGQLError } from "data/functions";

export function ExtPaymentCreateMutation() {
  const queryName = "ExtPaymentCreate";
  const [mutation, variables] = useMutation(EXPORT_PAYMENT_CREATE, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if (data?.export_paymentCreate.code === 200) {
      } else {
        logGQLError(queryName, data?.export_paymentCreate);
      }
    },
    onError: (e) => {
      logGQLError(queryName, e);
    },
  });
  return [mutation, variables];
}
